const topics = [
  { label: '精品推荐', heat: '9.8w', tag: 'hot' },
  { label: '最新上架', heat: '7.3w', tag: 'new' },
  { label: '经典回顾', heat: '6.5w', tag: '' },
  { label: '独家内容', heat: '5.9w', tag: 'exclusive' },
  { label: '高人气的', heat: '5.2w', tag: '' },
  { label: '合集连载', heat: '4.8w', tag: '' },
  { label: '稀有资源', heat: '4.1w', tag: 'rare' },
  { label: '每周精选', heat: '3.6w', tag: '' },
  { label: '新人推荐', heat: '3.2w', tag: 'new' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="scroll-mt-16 py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
            热门话题
          </h2>
          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic) => (
              <a
                key={topic.label}
                href="#topics"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-100 border border-background-200/70 rounded-full hover:border-primary-300 hover:bg-primary-50 transition-all duration-200 cursor-pointer group"
              >
                <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  {topic.label}
                </span>
                <span className="text-xs text-foreground-400 font-medium">{topic.heat}</span>
                {topic.tag === 'hot' && (
                  <span className="px-1.5 py-0.5 text-[10px] font-bold text-accent-600 bg-accent-100 rounded-full whitespace-nowrap">热</span>
                )}
                {topic.tag === 'new' && (
                  <span className="px-1.5 py-0.5 text-[10px] font-bold text-secondary-600 bg-secondary-100 rounded-full whitespace-nowrap">新</span>
                )}
                {topic.tag === 'exclusive' && (
                  <span className="px-1.5 py-0.5 text-[10px] font-bold text-primary-600 bg-primary-100 rounded-full whitespace-nowrap">独家</span>
                )}
                {topic.tag === 'rare' && (
                  <span className="px-1.5 py-0.5 text-[10px] font-bold text-accent-600 bg-accent-100 rounded-full whitespace-nowrap">稀有</span>
                )}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}